module.exports = __webpack_public_path__ + "bb5eef54d43363cbbce55f85971aff72.fbx";